import * as actionTypes from './actionTypes';
import { typePublicationService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { fetchValidateAccess, fetchValidate } from '@app/src/common/session';

const fetchTypePublicationRequest = () => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_REQUEST
});

const fetchTypePublicationSuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_SUCCESS,
  data
});

const fetchTypePublicationFailure = () => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_FAILURE
});

export const setTypePublicationSelected = (value: TypePublicationModel | {}) => ({
  type: actionTypes.SET_TYPE_PUBLICATION_SELECTED,
  value
});

export const clearTypePublicationAll = () => ({
  type: actionTypes.CLEAR_TYPE_PUBLICATION_ALL
});

export const fetchTypePublication = (idCategory: number, idOperation?: number, idOwnInput?: number): Function => {
  return async dispatch => {
    dispatch(fetchTypePublicationRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await typePublicationService.get(idCategory, idOperation, idOwnInput);
      dispatch(fetchTypePublicationSuccess(data));
    } catch (e) {
      dispatch(fetchTypePublicationFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};

export const fetchTypePublicationPackage = (userId: number, categoryId: number, packageId: number, operationId?: number, ownInputId?: number): Function => {
  return async dispatch => {
    dispatch(fetchTypePublicationRequest());
    await dispatch(fetchValidate());
    try {
      const data = await typePublicationService.getAvailable(userId, categoryId, packageId, operationId, ownInputId);
      dispatch(fetchTypePublicationSuccess(data));
    } catch (e) {
      dispatch(fetchTypePublicationFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
